// Desktop v3 media (D_Desk prototype): per buddy, a day and a night set of the room (still + loop), the mini window
// (still + loop) and the glance / nod reactions for both. Files: public/assets/<ch>/desk/<time>-<kind>.<ext>.
// Every buddy x time x kind exists, so no fallback is needed. Videos are H.264 .mp4 with no audio; stills are .jpg.
import type { CharId } from '@shared/types';

export type DeskTime = 'day' | 'night';

/**
 * room / loop: the room still and its loop (16:9). pip / piploop: the mini-window still and loop (4:5).
 * glance / nod: mini-window reactions; rglance / rnod: room reactions. `_s` is the still of that reaction.
 */
export type DeskKind =
  | 'room' | 'loop' | 'pip' | 'piploop'
  | 'glance' | 'nod' | 'glance_s' | 'nod_s'
  | 'rglance' | 'rnod' | 'rglance_s' | 'rnod_s';

const EXT: Record<DeskKind, 'jpg' | 'mp4'> = {
  room: 'jpg', loop: 'mp4', pip: 'jpg', piploop: 'mp4',
  glance: 'mp4', nod: 'mp4', glance_s: 'jpg', nod_s: 'jpg',
  rglance: 'mp4', rnod: 'mp4', rglance_s: 'jpg', rnod_s: 'jpg',
};

export function deskAsset(ch: CharId, time: DeskTime, kind: DeskKind): string {
  return `/assets/${ch}/desk/${time}-${kind}.${EXT[kind]}`;
}
